const GENERIC_TYPES = new Set([
  'establishment',
  'point_of_interest',
  'food',
  'store',
  'geocode',
  'plus_code',
  'premise',
  'street_address',
]);

/**
 * Pick the most specific non-generic type from Google's `types` array.
 * Returns null when the array is empty or only contains generic tags.
 */
export function pickPrimaryType(types: readonly string[] | undefined): string | null {
  if (!types || types.length === 0) return null;
  const specific = types.find((t) => !GENERIC_TYPES.has(t));
  return specific ?? types[0] ?? null;
}

/** Format a raw Google type ("shopping_mall") as a user-facing label ("Shopping mall"). */
export function formatTypeLabel(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const spaced = raw.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}
